import apiCompetitions from '@/api/competition'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createCompetitionStart:
    '[create competition plan] Create competition plan start',
  createCompetitionSuccess:
    '[create competition plan] Create competition plan success',
  createCompetitionFailure:
    '[create competition plan] Create competition plan failure',

  createCalendarPlanClearError:
    '[create competition plan] Create competition plan clear error',
}

export const actionTypes = {
  createCompetition: '[create competition plan] Create competition plan',
}

const mutations = {
  [mutationTypes.createCompetitionStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createCompetitionSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createCompetitionFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.createCalendarPlanClearError](state) {
    state.error = null
  },
}

const actions = {
  [actionTypes.createCompetition](context, {calendarPlan}) {
    context.commit(mutationTypes.createCompetitionStart)
    return new Promise((resolve) => {
      apiCompetitions
        .addCompetitionCalendarPlans(calendarPlan)
        .then((response) => {
          context.commit(mutationTypes.createCompetitionSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createCompetitionFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
